import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { FacebookShareButton, TwitterShareButton, PinterestShareButton, WhatsappShareButton } from 'react-share';
import { colorPalette } from '../styles/styleGuide';
import FacebookIcon from './shared/icons/Facebook';
import TwitterIcon from './shared/icons/Twitter';
import PinterestIcon from './shared/icons/Pinterest';
import ClipboardIcon from './shared/icons/Clipboard';
import CheckIcon from './shared/icons/Check';
import WhatsappIcon from './shared/icons/Whatsapp';
import MailIcon from './shared/icons/Message';
var SocialShare = /*#__PURE__*/function (_Component) {
  function SocialShare() {
    var _this;
    _classCallCheck(this, SocialShare);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SocialShare, [].concat(args));
    _defineProperty(_this, "state", {
      hasCopiedToClipboard: false
    });
    _defineProperty(_this, "addClipboardData", function () {
      var shareUrl = _this.props.shareLink;
      var body = document.querySelector('body');
      var copyFrom = document.createElement('textarea');
      copyFrom.textContent = shareUrl;
      if (body) {
        body.appendChild(copyFrom);
        copyFrom.select();
        document.execCommand('copy');
        body.removeChild(copyFrom);
      }
      _this.setState({
        hasCopiedToClipboard: true
      });
    });
    return _this;
  }
  _inherits(SocialShare, _Component);
  return _createClass(SocialShare, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        shareLink = _this$props.shareLink,
        image = _this$props.image,
        colorPrimary = _this$props.colorPrimary,
        colorSecondary = _this$props.colorSecondary,
        _this$props$buttons = _this$props.buttons,
        buttons = _this$props$buttons === void 0 ? [] : _this$props$buttons;
      var shareUrl = shareLink;
      var socialButtons = function socialButtons(button) {
        switch (button.type) {
          case 'facebook':
            return __jsx(FacebookShareButton, {
              url: shareUrl,
              image: image,
              "data-id": "components_SocialShare_FacebookShareButton"
            }, __jsx(IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, __jsx(FacebookIcon, {
              "data-id": "components_SocialShare_FacebookIcon"
            })));
          case 'twitter':
            return __jsx(TwitterShareButton, {
              url: shareUrl,
              "data-id": "components_SocialShare_TwitterShareButton"
            }, __jsx(IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, __jsx(TwitterIcon, {
              "data-id": "components_SocialShare_TwitterIcon"
            })));
          case 'pinterest':
            return __jsx(PinterestShareButton, {
              url: shareUrl,
              media: image,
              "data-id": "components_SocialShare_PinterestShareButton"
            }, __jsx(IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, __jsx(PinterestIcon, {
              "data-id": "components_SocialShare_PinterestIcon"
            })));
          case 'clipboard':
            return __jsx("div", {
              onClick: _this2.addClipboardData,
              "data-id": "components_SocialShare_div"
            }, __jsx(IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, _this2.state.hasCopiedToClipboard ? __jsx(CheckWrapper, {
              "data-id": "components_SocialShare_CheckWrapper"
            }, __jsx(CheckIcon, {
              color: colorPalette.white,
              "data-id": "components_SocialShare_CheckIcon"
            })) : __jsx(ClipboardIcon, {
              "data-id": "components_SocialShare_ClipboardIcon"
            })));
          case 'whatsapp':
            return __jsx(WhatsappShareButton, {
              url: shareUrl,
              "data-id": "components_SocialShare_WhatsappShareButton"
            }, __jsx(IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, __jsx(WhatsappIcon, {
              "data-id": "components_SocialShare_WhatsappIcon"
            })));
          case 'mail':
          default:
            return __jsx(Link, {
              href: "mailto:?body=".concat(shareUrl),
              "data-id": "components_SocialShare_Link"
            }, __jsx(IconWrapper, {
              "data-id": "components_SocialShare_IconWrapper"
            }, __jsx(MailIcon, {
              width: 24,
              height: 16,
              color: colorPalette.white,
              "data-id": "components_SocialShare_MailIcon"
            })));
        }
      };
      return __jsx(View, {
        "data-id": "components_SocialShare_View"
      }, buttons.map(function (btn, index) {
        return __jsx(ShareBtn, {
          key: index,
          colorPrimary: colorPrimary,
          colorSecondary: colorSecondary,
          "data-id": "components_SocialShare_ShareBtn"
        }, socialButtons(btn));
      }));
    }
  }]);
}(Component);
export default SocialShare;
var View = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  margin-bottom: 50rem;\n"])));
var Link = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n"])));
var ShareBtn = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  float: left;\n  width: 40rem;\n  height: 40rem;\n  margin-right: 10rem;\n  margin-bottom: 10rem;\n  background-color: ", ";\n  transition: background-color 0.25s ease-in-out;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.colorPrimary;
}, function (props) {
  return props.colorSecondary;
});
var CheckWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 25rem;\n  height: 25rem;\n  position: relative;\n\n  svg {\n    position: relative;\n    transform: scale(1.4);\n    top: 2rem;\n    left: 5rem;\n  }\n"])));
var IconWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  height: 40rem;\n  align-items: center;\n  justify-content: center;\n"])));